define('views/modules/calendar/calendar/calendar-component/item/calendar-item-add-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils', 'bootbox',
    // services
    'services/i18n',
    // views
    'views/parts/list/fetch-list',
    'views/modules/calendar/calendar/calendar-component/item/calendar-day-item',
    'views/modules/feedback/modal/feedback-modal-mixin',
    // templates
    'text!templates/modules/calendar/calendar/calendar-component/item/calendar-item-add-list.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U, Bootbox,
    // services
    i18n,
    // views
    VFetchList,
    VCalendarDayItem,
    VFeedbackModalMixin,
    // templates
    TCalendarItemAddList
) {

    var VCalendarItemAddList = VFetchList.extend(_.extend({
        template: TCalendarItemAddList,
        item: VCalendarDayItem,

        regions: {
            list: '.calendar-items',
        },

        initialize: function(opt) {
            opt = _.extend({}, opt);
            _.extend(this, { view: {} });

            this.setUrl('root', opt.url + moment().format('YYYY-MM-DD'));
            this.initFeedbackListener();

            VCalendarItemAddList.__super__.initialize.call(this, opt);
        },

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, 'url', 'summary'), {
                duplicate: false
            });
        },

        toggle: function(value) {
            if (!_.isUndefined(value)) value = !value;
            this.$el.toggleClass('hidden', value);
        },

        toggleList: function(value) {
            if (!_.isUndefined(value)) value = !value;
            this.zone.$list.toggleClass('hidden', value);
        },

    }, VFeedbackModalMixin));

    return VCalendarItemAddList;
});

